// Translations
export const T = {
  en_GB: {
    saveFailed: "The override could not be saved.",
    resetFailed: "The override could not be reset. Try again in a moment.",
  },
  nb_NO: {
    saveFailed: "Overstyringen kunne ikke lagres.",
    resetFailed: "Overstyringen kunne ikke tilbakestilles. Prøv igjen om litt.",
  },
} as const;
